// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox__3weC_","checked":"Checkbox_checked__2Gh-t"};